var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"incidente-root",attrs:{"fluid":""}},[_c('div',[_c('h2',[_vm._v("Evaluación")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"12"}},[_c('div',[_c('en-desarrollo',{attrs:{"titulo":"Evaluación"}})],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }